import React, { useState, useMemo, useEffect } from 'react'
import ProgramsSectionTitle from '../ProgramsSectionTitle';
import { IndustryPartnerProgramsData } from "../../../IndustryPartnerProgramsData.js";
import Select from 'react-select';
import { Element } from 'react-scroll';

const ProgramsListing = () => {
  const [selectedFilters, setSelectedFilters] = useState({
    sector: null,
    format: null,
    duration: null,
  });

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  // Extract unique options dynamically // If we want to always show all filters
  // const allSectors = [...new Set(IndustryPartnerProgramsData.map(p => p.sector))];
  // const allFormats = [...new Set(IndustryPartnerProgramsData.map(p => p.format))];
  // const allDurations = [...new Set(IndustryPartnerProgramsData.map(p => p.duration))];

  // Filtered data based on current selections
  const filteredData = useMemo(() => {
    return IndustryPartnerProgramsData.filter(program => {
      return (
        (!selectedFilters.sector || program.sector === selectedFilters.sector.value) &&
        (!selectedFilters.format || program.format === selectedFilters.format.value) &&
        (!selectedFilters.duration || program.duration === selectedFilters.duration.value)
      );
    });
  }, [selectedFilters]);

  // Reset to first page when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [selectedFilters]);

  // Dynamically update available options based on current filtered data
  const dynamicSectors = [...new Set(filteredData.map(p => p.sector))];
  const dynamicFormats = [...new Set(filteredData.map(p => p.format))];
  const dynamicDurations = [...new Set(filteredData.map(p => p.duration))];

  const sectorOptions = dynamicSectors.map(s => ({ value: s, label: s }));
  const formatOptions = dynamicFormats.map(f => ({ value: f, label: f }));
  const durationOptions = dynamicDurations.map(d => ({ value: d, label: d }));

  const handleFilterChange = (selectedOption, filterName) => {
    setSelectedFilters(prev => ({
      ...prev,
      [filterName]: selectedOption
    }));
  };

  // Pagination logic
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = filteredData.slice(startIndex, startIndex + itemsPerPage);

  const goToPage = (pageNum) => {
    setCurrentPage(pageNum);
  };

  return (
    <>
      <Element className="datatalent-section-gap" name="ipp-list">
        <div className="container eduvibe-animated-shape">
          <div className="row g-5">
            <div className="col-12 col-lg-6 mt-0 px-0 px-md-4">
              <ProgramsSectionTitle
                classes="text-start"
                title="Our Programs"
              />
              <p className="mb-0">Showing {filteredData.length} of {IndustryPartnerProgramsData.length} programs</p>
            </div>
            <div className="col-12 col-lg-6 mt-4 mt-md-0 px-0 px-md-4 d-flex row g-4 flex-wrap justify-content-md-end align-items-md-end">
              <div className="col-12 col-md-4 p-0 px-md-2">
                <Select
                  className="basic-single"
                  placeholder="Sectors..."
                  onChange={opt => handleFilterChange(opt, "sector")}
                  isClearable="true"
                  name="sector"
                  value={selectedFilters.sector}
                  options={sectorOptions}
                />
              </div>
              <div className="col-12 col-md-4 p-0 px-md-2">
                <Select
                  className="basic-single"
                  placeholder="Formats..."
                  onChange={opt => handleFilterChange(opt, "format")}
                  isClearable="true"
                  name="format"
                  options={formatOptions}
                  value={selectedFilters.format}
                />
              </div>
              <div className="col-12 col-md-4 p-0 px-md-2">
                <Select
                  className="basic-single"
                  placeholder="Durations..."
                  onChange={opt => handleFilterChange(opt, "duration")}
                  isClearable="true"
                  name="duration"
                  options={durationOptions}
                  value={selectedFilters.duration}
                />
              </div>
            </div>
            <div className="col-12 p-0">
              <div className="d-flex flex-row flex-wrap">
                {filteredData.length === 0 ? (
                  <p>
                    No Programs found. Please try less filters.
                  </p>
                  ) : (currentItems.map((program) => 
                  <div className="col-12 col-lg-4 py-3 p-md-4" key={program.id}>
                    <div className="ipp-card rounded-4 overflow-hidden">
                      <div className="ipp-card-image position-relative">
                        <img src={program.image} alt={program.title} />
                        <div className="ipp-card-sector">
                          {program.sector}
                        </div>
                        <div className="ipp-card-price">
                          {program.price}
                        </div>
                      </div>
                      <div className="ipp-card-content border rounded-bottom-4 p-4 d-flex flex-column justify-content-between">
                        <div className="ipp-card-content-wrapper">
                          <h6 className="mb-0">{program.title}</h6>
                          <p className="mb-0">{program.description}</p>
                          <div className="d-flex flex-row mt-4">
                            <div className="col-6 d-flex flex-row align-items-center gap-2">
                              <i className="icon-map-pin-line"></i> {program.format}
                            </div>
                            <div className="col-6 d-flex flex-row align-items-center gap-2">
                              <i className="icon-time-line"></i> {program.duration}
                            </div>
                          </div>
                          <p className="mb-2 mt-4"><strong>Key Skills:</strong></p>
                          <div className="d-flex flex-row flex-wrap gap-2">
                            {program.skills.map((skill, skillIdx) => (
                              <div className="ipp-card-skill" key={skillIdx}>
                                {skill}
                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="d-flex flex-row justify-content-between mt-4">
                          <a className="edu-btn btn-medium btn-bg-alt" href={program.link}>Learn More</a>
                          <a className="edu-btn btn-medium btn-primary" href={program.applyLink}>Apply Now</a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {/* Pagination Controls */}
              {filteredData.length > itemsPerPage && (
                <div className="pagination d-flex justify-content-center mt-5">
                  <button 
                    onClick={() => goToPage(currentPage - 1)} 
                    disabled={currentPage === 1} 
                    className={`edu-btn btn-small mx-1 ${currentPage === 1 && "disabled"}`}
                  >
                    Previous
                  </button>
                  {Array.from({ length: totalPages }, (_, i) => i + 1).map(num => (
                    <button 
                      key={num} 
                      onClick={() => goToPage(num)} 
                      className={`edu-btn btn-small lh-1 mx-1 ${num === currentPage ? "btn-primary" : "btn-bg-alt"}`}
                    >
                      {num}
                    </button>
                  ))}
                  <button 
                    onClick={() => goToPage(currentPage + 1)} 
                    disabled={currentPage === totalPages} 
                    className={`edu-btn btn-small mx-1 ${currentPage === totalPages && "disabled"}`}
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default ProgramsListing;